<template>
	<div class="Minister-top Ministerborder">
		<div class="Minister-top-top Ministerbackground">
			<div class="Minister-top-left Minister-top-color">变体信息</div>
			<!-- <div class="Minister-top-right Minister-top-color" @click="Variant">{{ variantcontent }}</div> -->
		</div>

		<div class="variant" v-if="varianttypt">
			<div class="variant_top">
				<span style="padding: 0 10px 0 0">变体</span>
				<el-button @click="addVariant" class="mr20">添加变体</el-button>
				<span style="padding: 0 10px 0 0">变体主题：</span>
				<el-select
					v-model="variation_theme"
					placeholder="请选择"
					size="mini"
					class="mr20"
					filterable allow-create clearable
					@input="variation_theme = variation_theme ? variation_theme.replace(/\s/g, '') : ''"
				>
					<el-option
						v-for="item in variation_theme_list"
						:key="item"
						:label="item"
						:value="item"
					></el-option>
				</el-select>
				<div class="tip">
					如果下拉框中缺失变体主题，请手动添加 <span style="color: red;">颜色：COLOR、尺寸：SIZE、产品数量：NUMBER_OF_ITEMS</span>，请按listing页面中的顺序添加，确保同步Listing之后能自动识别，多个使用/拼接
				</div>
			</div>
			<div style="padding: 10px;" class="select-row">
				<el-input v-model="filterDelete.color" placeholder="颜色" clearable
					style="width: 100%;" />
				<el-input v-model="filterDelete.size" placeholder="尺寸" clearable
					style="width: 100%;" />
				<el-input v-model="filterDelete.number_of_items" placeholder="产品数量" clearable
					style="width: 100%;" />
				<el-button type="primary"  @click="filterBatchDelete">删除匹配的行</el-button>
			</div>
			<div class="active_variants">
				<template v-for="(value, key, index) in selectVariants">
					<div class="active_variants_item" :key="index" v-if="value.length">
						<el-button size="mini" @click="addSizeColor(value, key)">{{
							key
						}}</el-button>
						<el-tag size="small" :closable="pageType !== 'wait'"
							style="height: 29px; margin-left: 10px; line-height: 28px" @close="delet(key)">{{ key }}
						</el-tag>
					</div>
				</template>
			</div>
			<div class="variant_content">
				<div class="summary_list">
					<el-table
						border
						:data="tableData"
						style="width: 100%"
						v-loading="loadingTable"
						size="mini"
					>
						<el-table-column
							width="120"
							prop="color"
							label="颜色"
							align="center"
							v-if="isShowColor"
						></el-table-column>
						<el-table-column
							width="120"
							prop="size"
							label="尺寸"
							align="center"
							v-if="isShowSize"
						></el-table-column>
						<el-table-column width="120" prop="numberOfItems" label="产品数量" align="center"
							v-if="isShowProcuctNumber"></el-table-column>
						<el-table-column
							width="200"
							prop="variantTag"
							label="变体标识"
							align="center"
						></el-table-column>
						<el-table-column
							width="140"
							align="center"
							v-if="pageType !== 'wait'"
						>
							<template slot="header">
								重新定价
								<el-popover trigger="hover" placement="top">
									<p>
										如果变体价格需要重新估价,可点击重新定价
									</p>
									<i
										class="iconfont icon-tishi"
										slot="reference"
									></i>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<el-button
									style="width: 100%"
									type="primary"
									@click="Viewpricing(scope.row)"
									>一键定价</el-button
								>
								<el-select
									v-model="variant_price_value"
									@change="
										Repricing(
											variant_price_value,
											scope.row
										)
									"
								>
									<el-option
										key="all"
										label="所有变体"
										value="all_variant"
									></el-option>
									<template v-if="isSyncInfoList">
										<el-option
											v-for="(item, i) in specs"
											:key="i"
											:label="'相同' + item.title"
											:value="item.title"
										></el-option>
									</template>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column
							width="160"
							label="加减价"
							align="center"
						>
							<template slot-scope="scope">
								<el-input
									v-model="scope.row.inputPrice"
									@change="calculate_Variant_price(scope.row)"
								></el-input>
								<el-select
									v-model="variant_price_same_value"
									@change="
										VariantPriceSame(
											variant_price_same_value,
											scope.row
										)
									"
								>
									<el-option
										key="all"
										label="所有变体"
										value="all_variant"
									></el-option>
									<template v-if="isSyncInfoList">
										<el-option
											v-for="(item, i) in specs"
											:key="i"
											:label="'相同' + item.title"
											:value="item.title"
										></el-option>
									</template>
								</el-select>
							</template>
						</el-table-column>
						<!-- :formatter="stateFormat" -->
						<el-table-column
							label="结果价"
							width="100"
							prop="showPrice"
							align="center"
						>
							<template slot-scope="scope">
								<!-- <template v-if="pageType === 'wait'">
                                    <el-input placeholder="请输入内容" v-model="scope.row.showPrice"></el-input>
                                </template>
                <template v-else>-->
								<span>{{
									stateFormat(scope.row) +
										calcCurrency(scope.row)
								}}</span>
								<!-- </template> -->
							</template>
						</el-table-column>
						<el-table-column
							width="100"
							label="库存"
							align="center"
						>
							<template slot-scope="scope">
								<el-input v-model="scope.row.stock"></el-input>
							</template>
						</el-table-column>
						<el-table-column
							width="200"
							v-if="substitution"
							align="center"
						>
							<template slot="header">
								UPC/EAN
								<el-button type="text">批量置换</el-button>
							</template>
							<template slot-scope="scope">
								<el-input
									v-model="scope.row.UPC_EAN"
								></el-input>
							</template>
						</el-table-column>
						<el-table-column align="center">
							<template slot="header">
								<span>子SKU</span>
								<el-button
									type="text"
									@click="handleSKU"
									v-if="pageType === 'wait'"
									>一键生成SKU</el-button
								>
							</template>
							<template slot-scope="scope">
								<el-input
									v-model="scope.row.sku"
									placeholder
									style="font-size: 12px"
									maxlength="40"
								></el-input>
								<!-- :readonly="pageType !== 'wait'" -->
							</template>
						</el-table-column>
						<el-table-column
							width="240"
							label="图片"
							align="center"
						>
							<template slot-scope="scope">
								<template v-if="scope.row.imagesList.length">
									<ul
										class="checked-img-container"
										v-if="
											scope.row.imagesList &&
												scope.row.imagesList.length
										"
									>
										<li
											class="img-box"
											@click="
												Selected_pictures(
													scope.row,
													scope.$index
												)
											"
											v-for="(item,
											index) in scope.row.imagesList.slice(
												0,
												3
											)"
											:key="item"
										>
											<img
												style="width: 100%"
												:src="item"
												alt
											/>
											<i
												class="el-icon-circle-close"
												@click.stop="
													handleRemove(
														scope.row,
														index
													)
												"
											></i>
										</li>
										<li
											class="img-box"
											v-show="
												scope.row.imagesList.length > 3
											"
										>
											...
										</li>
										<el-button
											type="mini"
											icon="el-icon-plus"
											@click="Select_pictures(scope.row)"
										></el-button>
									</ul>
									<el-select
										v-model="Selected_pictures_value"
										placeholder="请选择"
										v-show="scope.row.imagesList.length > 0"
										@change="
											Selected_picturesSame(
												Selected_pictures_value,
												scope.row
											)
										"
										style="width: 100%"
									>
										<el-option
											key="all"
											label="所有变体"
											value="all_variant"
										></el-option>
										<template v-if="isSyncInfoList">
											<el-option
												v-for="(item, i) in specs"
												:key="i"
												:label="'相同' + item.title"
												:value="item.title"
											></el-option>
										</template>
									</el-select>
								</template>
								<template v-else>
									<el-button
										@click="Select_pictures(scope.row)"
										>选择图片</el-button
									>
								</template>
							</template>
						</el-table-column>
						<el-table-column
							label="操作"
							align="center"
							width="100"
						>
							<template slot-scope="scope">
								<el-button
									@click.native.prevent="
										deleteRow(scope.row, scope.$index)
									"
									type="text"
									size="small"
									>删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<el-dialog
			title="变体设置"
			class="uploaderImg"
			:visible.sync="dialogVariantVisible"
		>
			<el-tabs type="border-card" v-model="activeName">
				<el-tab-pane label="常用变体组合" name="常用变体组合">
					<div class="mb10">您有以下最近使用变体组合</div>
					<div class="keyword-list box">
						<template v-if="historyVariantTag.length">
							<div class="item" v-for="(item, index) in historyVariantTag" :key="item">
								<el-radio class="variant-radio" v-model="historyValueTag" border :label="item">{{ item }}</el-radio>
								<el-button type="danger" @click="deleteVariantTag(item, index)">删除</el-button>
							</div>
							
						</template>
						<div class="no-data" v-else>暂无数据</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="常用变体" name="常用变体">
					<div class="mb10">您有以最近使用变体</div>
					<div class="keyword-list">
						<div v-if="historyVariants.length">
							<el-radio v-for="item in historyVariants" :key="item" v-model="historyValue" border :label="item">{{ item}}</el-radio>
						</div>
						<div class="no-data" v-else>暂无数据</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="所有变体" name="所有变体">
					<div>
						变体名称:
						<el-select
							size="mini"
							v-model="specsIndex"
							placeholder="请选择变体名称"
							@change="getVariantSelect"
						>
							<el-option
								:label="item.title"
								:key="index"
								:value="item.title"
								v-for="(item, index) in specs"
							></el-option>
						</el-select>
					</div>
					<div style="margin-top: 10px">
						变体值:(多个值用逗号隔开如:red,white,black,)
						<br />
						<el-input
							placeholder="多个值用英文逗号隔开如:red,white,black"
							style="margin-top: 5px; margin-bottom: 5px; width: 70%"
							size="mini"
							type="texteara"
							v-model="variantText"
						></el-input>
					</div>
					<div>
						<el-tabs
							class="rs-tab"
							v-if="recommendSpecs && recommendSpecs.length > 0"
							tab-position="left"
						>
							<el-tab-pane
								v-for="(item, index) in recommendSpecs"
								:key="index"
								:label="item.title"
							>
								<ul>
									<li
										style="padding: 0 3px; cursor: pointer"
										v-for="(sub_item, i) in item.list"
										v-text="sub_item"
										@click="putText(sub_item)"
										:key="i"
									></li>
								</ul>
							</el-tab-pane>
						</el-tabs>
					</div>
					
				</el-tab-pane>
			</el-tabs>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="dialogVariantVisible = false"
					>取 消</el-button
				>
				<el-button
					size="mini"
					type="primary"
					@click="saveVariantInfoEdit1"
					>确 定</el-button
				>
			</div>
		</el-dialog>
		<el-dialog
			title="选择图片"
			class="uploaderImgVariant"
			:visible.sync="dialogFormVisible"
			width="1000px"
			@close="variantSelectImgDialogClose"
		>
			<el-alert
				title="变体图片最多选择9张"
				type="error"
				:closable="false"
			></el-alert>
			<el-divider></el-divider>
			<ul class="select-img" v-if="imgSelectList.length">
				<li
					class="option"
					v-for="(item, index) in imgSelectList"
					:key="item"
					@click="changeVariantSelectImg(item, index, $event)"
				>
					<div
						class="img-mask"
						v-if="
							variantCheckedImgUidList.some((key) => key === item)
						"
					>
						<i class="el-icon-upload-success el-true-check">
							{{ getVariantSelectImgIndex(item) }}
						</i>
					</div>
					<img :src="item" alt />
				</li>
			</ul>
			<el-divider v-if="imgSelectList.length"></el-divider>
			<el-upload
				class="custom-update"
				:action="upload_url"
				accept="image/gif, image/jpeg, image/tiff"
				drag
				multiple
				:show-file-list="false"
				list-type="picture-card"
				:on-success="uploadVariantImagesSuccess"
				:headers="customHeaders"
			>
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">
					将图片拖到此处，或
					<em>点击上传</em>
				</div>
				<div class="el-upload__tip" slot="tip">
					<p>
						图片可批量上传，只支持
						<span style="color:red;font-weight:bold;"
							>JPG/TIFF/JPEG</span
						>
						格式图片，首选
						<span style="color:red;font-weight:bold;">JPEG</span>
						格式， 图片的最长边不应低于
						<span style="color:red;font-weight:bold;">1600</span>
						像素，最长边不得超过
						<span style="color:red;font-weight:bold;">10,000</span>
						像素，不能包含徽标或水印。商品必须是填满
						<span style="color:red;font-weight:bold;">85%</span>
						的图片,图片详细标准请参阅Amazon平台要求。
					</p>
				</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="dialogFormVisible = false"
					>取 消</el-button
				>
				<el-button
					size="mini"
					type="primary"
					@click="saveVariantSelectImg()"
					>确 定</el-button
				>
			</div>
		</el-dialog>
		<el-dialog
			title="已选图片"
			class="uploaderImgVariant"
			:visible.sync="isShowVariantImg"
			width="1000px"
		>
			<div class="image-container">
				<div
					class="img-box"
					v-for="item in variantImages"
					:key="item.uid"
				>
					<img :src="item" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowVariantImg = false"
					>取 消</el-button
				>
				<el-button
					size="mini"
					type="primary"
					@click="isShowVariantImg = false"
					>确 定</el-button
				>
			</div>
		</el-dialog>
		<one-click-price
			ref="OneClickPrice"
			:exchange-rate-list="exchangeRateList"
			@confirm="getMsgFormSon"
			:productPriceObject="priceData"
		/>
	</div>
</template>
<script>
import sizeList from './Choice/sizeList'
import colorList from './Choice/colorList'
import productNumberList from './Choice/productNumberList'
import pageOutputList from './Choice/pageOutputList'
import OneClickPrice from '../elasticFrame/OneClickPrice'
import { Baseurl } from '@/api/api/api'
const VARIANT_ORDER = ['颜色', '尺寸', '产品数量']
export default {
	components: {
		OneClickPrice,
	},
	props: {
		pageType: {
			type: String,
			default: '',
		},
		productInfo: {
			type: Object,
			default() {
				return {}
			},
		},
		imgSelectList: {
			type: Array,
			default() {
				return []
			},
		},
		exchangeRateList: {
			type: Array,
			default() {
				return []
			},
		},
	},
	data() {
		return {
			priceData: {},
			historyValue:'',
			historyValueTag: '',
			variantcontent: '展开',
			varianttypt: true,
			specsIndex: '', //颜色尺寸
			variantText: '', //选择尺寸和颜色后获取的值
			recommendSpecs: {}, //显示尺寸和颜色的规格
			tableData: [],
			ossParams: {},
			// 颜色 和 尺寸 的先后顺序决定变体标识，不可换！！！
			selectVariants: {
				颜色: [],
				尺寸: [],
			},
			dialogVariantVisible: false, //变体设置
			specs: VARIANT_ORDER.map(item => { 
				return {
					title: item,
				}
			}),
			filterDelete: {
				color: '',
				size: '',
				number_of_items: '',
				unit_count: '',
				mode: 'delete' // delete | keep
			},
			variation_theme_list: [
				"COLOR/SIZE",
				"COLOR/NUMBER_OF_ITEMS"
			],
			variation_theme: '',
			dialogType: '',
			dialogFormVisible: false, //选择图片
			dialogVisible: false, //放大图片
			isShowVariantImg: false, //已选图片
			dialogImageUrl: '',
			variant_price_same_value: '', //加减价/￥
			variant_price_value: '', //重新定价
			variantImages: [], //已选图片
			Selected_pictures_value: '', //已选图片选择变体的值
			substitution: false,
			variantSelectImage_form: {
				variant: '',
				index: '',
				images: [],
				images_sort: [],
			},
			upload_url: Baseurl + 'imageController/uploadImage',

			childValue: '',
			// productPicUrl: [],
			// fatherSKU: "",
			// watchfather: "",
			checkedSKU: '',
			variantCheckedImgUidList: [],
			customHeaders: { token: localStorage.getItem('token') },
			loadingTable: false,
			historyVariants:[],
			historyVariantTag: [],
			activeName: '常用变体组合',
			lastSelectedIndex: null, // 记录上一次点击的index
		}
	},
	mounted() {
		let historyVariant = localStorage.getItem('historyVariant');
		historyVariant = historyVariant ? JSON.parse(historyVariant) : [];
		this.historyVariants = historyVariant.reverse(); //倒序，最新的在上面

		let historyVariantTag = localStorage.getItem('historyVariantTag');
		historyVariantTag = historyVariantTag ? JSON.parse(historyVariantTag) : [];
		this.historyVariantTag = historyVariantTag.reverse(); //倒序，最新的在上面

		let variation_theme_list1 = localStorage.getItem('variation_theme_list');
		if(variation_theme_list1){
			this.variation_theme_list = JSON.parse(variation_theme_list1);
		}
		this.substitution = this.$route.query.substitutionTrue
		if (this.substitution === undefined) {
			this.substitution = false
		} else {
			this.substitution = this.$route.query.substitutionTrue
		}
	},
	computed: {
		isSyncInfoList() {
			for (const item in this.selectVariants) {
				if (!this.selectVariants[item].length) {
					return false
				}
			}
			return true
		},
		isShowColor() {
			return this.tableData.length && this.tableData[0].color
		},
		isShowSize() {
			return this.tableData.length && this.tableData[0].size
		},
		isShowProcuctNumber() {
			return this.tableData.length && this.tableData[0].numberOfItems
		},
		isShowPageOutput() {
			return this.tableData.length && this.tableData[0].unitCount
		},
	},
	methods: {
		deleteVariantTag(item, index){
			this.historyVariantTag.splice(index, 1);
			localStorage.setItem('historyVariantTag', JSON.stringify(this.historyVariantTag));
		},
		filterBatchDelete() {
			const { color, size, number_of_items, unit_count, mode } = this.filterDelete
			if (!color && !size && !number_of_items && !unit_count) {
				this.$message.warning('请至少选择一个条件')
				return
			}

			this.tableData = this.tableData.filter(item => {
				const matched =
					(!color || item.color === color) &&
					(!size || item.size === size) &&
					(!number_of_items || item.numberOfItems === number_of_items) &&
					(!unit_count || item.unitCount === unit_count)
				return !matched
			})
			const colorSet = new Set()
			const sizeSet = new Set()
			const numberOfItemsSet = new Set()
			const unitCountSet = new Set()

			this.tableData.forEach(item => {
				if (item.color) colorSet.add(item.color)
				if (item.size) sizeSet.add(item.size)
				if (item.numberOfItems) numberOfItemsSet.add(item.numberOfItems)
				if (item.unitCount) unitCountSet.add(item.unitCount)
			})

			this.selectVariants.颜色 = [...colorSet]
			this.selectVariants.尺寸 = [...sizeSet]
			this.selectVariants.产品数量 = [...numberOfItemsSet]
			this.$message.success('操作成功')
		},
		addTableData(table) {
			this.tableData = table
			// this.selectVariants = this.tableData
			const color = new Set([])
			const size = new Set([])
			const numberOfItems1 = new Set()
			const unitCount1 = new Set()
			this.$nextTick(() => {
				// 处理颜色尺寸标签
				this.tableData.forEach((item) => {
					item.color && color.add(item.color)
					item.size && size.add(item.size)
					item.numberOfItems && numberOfItems1.add(item.numberOfItems)
					item.unitCount && unitCount1.add(item.unitCount)
				})
				this.selectVariants.颜色 = [...color]
				this.selectVariants.尺寸 = [...size]
				this.selectVariants.产品数量 = [...numberOfItems1]
				// 处理排序
				this.tableData.sort((a, b) => a.variantOrder - b.variantOrder)
			})
		},
		changeLoading(loadingName) {
			this[loadingName] = false
		},
		variantSelectImgDialogClose() {
			this.variantCheckedImgUidList = []
		},
		getMsgFormSon(data, type = 'single') {
			console.log(data)
			// this.$set("Outcome", data.GB.value);
			if (this.tableData.length > 0) {
				this.tableData.forEach((item) => {
					if (type === 'single') {
						if (this.checkedSKU === item.sku) {
							item.productPrice = data
							item.showPrice = data.ZH.value
						}
					} else {
						item.productPrice = data
						item.showPrice = data[this.productInfo.areaName].value
					}
				})
			}
		},
		stateFormat(row) {
			const { inputPrice, showPrice } = row
			const handleInputPrice = this.toDecimal2(this.parseNum(inputPrice))
			return this.toDecimal2(
				this.parseNum(showPrice) + this.parseNum(handleInputPrice)
			)
		},
		calcCurrency(row) {
			if (
				row.productPriceObject &&
				Object.keys(row.productPriceObject).length
			) {
				return row.productPriceObject[row.areaName].currency
			} else {
				return 'CNY'
			}
		},
		Variant() {
			this.varianttypt = !this.varianttypt
			if (this.variantcontent === '展开') {
				this.variantcontent = '收起'
			} else {
				this.variantcontent = '展开'
			}
		},
		// 添加变体
		addVariant() {
			this.specsIndex = ''
			this.variantText = ''
			this.recommendSpecs = {}
			this.dialogVariantVisible = true
			this.dialogType = 'addVarant'
		},
		// 点击尺寸和颜色
		addSizeColor(value, key) {
			this.dialogVariantVisible = true
			this.dialogType = 'sVarant'
			this.specsIndex = key
			this.variantText = value.join(',')

			if (this.specsIndex === '尺寸') {
				this.recommendSpecs = sizeList.sizeList
			} else if(this.specsIndex === '颜色'){
				this.recommendSpecs = colorList.colorList
			}else if(this.specsIndex === '产品数量'){
				this.recommendSpecs = productNumberList.productNumberList
			}
		},
		// 获取变体 颜色和尺寸 组合的变体标识
		getvariantTag() {
			const listVariant = JSON.parse(JSON.stringify(this.selectVariants))
			const varinatData = []
			for (const key of VARIANT_ORDER) {
				if (listVariant[key] && listVariant[key].length) {
					varinatData.push(listVariant[key])
				}
			}
			if (!varinatData.length) return []
			return varinatData.reduce((a, b) =>
				a
					.map((aItem) => b.map((bItem) => `${aItem}&-;${bItem}`))
					.reduce((a, b) => [...a, ...b])
			)
		},
		saveVariantInfoEdit() {
			const variantTags = this.getvariantTag()
			// console.log(variantTags);
			// 根据组合好的变体标识生成表单数据
			const variantOrder = []
			for (const key of VARIANT_ORDER) {
				if (this.selectVariants[key] && this.selectVariants[key].length) {
					variantOrder.push(key)
				}
			}

			const tableData = variantTags.map((item) => {
				const parts = item.split('&-;');

				const getValue = (key) => {
					const idx = variantOrder.indexOf(key)
					return idx !== -1 ? (parts[idx] || '').trim() : ''
				}

				const color = getValue('颜色')
				const size = getValue('尺寸')
				const numberOfItems = getValue('产品数量')
				const correctVariantTag = item.replace(/&-;/g, '-')
				const tableItem = {
					areaName: this.productInfo.areaName,
					color,
					size,
					numberOfItems: numberOfItems,
					variantTag: correctVariantTag,
					sku: `${this.productInfo.sku}-${correctVariantTag}`,
					fatherSku: this.productInfo.sku,
					productPrice: this.productInfo.productPriceObject,
					stock: this.productInfo.stock,
					imagesList: [],
					inputPrice: '',
					eanUpc: '',
				}
				tableItem.showPrice = Object.keys(tableItem.productPrice).length
					? tableItem.productPrice.ZH
						? tableItem.productPrice.ZH.value
						: tableItem.productPrice[this.productInfo.areaName]
								.value
					: 0
				return tableItem
			})
			this.tableData.forEach((item) => {
				tableData.forEach((key) => {
					const result1 = item.color === key.color
					if (result1) {
						key.showPrice = item.showPrice
						key.productPrice = item.productPrice
						key.productPriceObject = item.productPriceObject
						key.stock = item.stock
						key.imagesList = item.imagesList
						key.inputPrice = item.inputPrice
						key.eanUpc = item.eanUpc
					}
				})
			})
			// console.log(tableData)
			this.tableData = tableData
			this.dialogVariantVisible = false
		},
		CheckArrayElement(arrData) {
			// arrData.sort() //数组排序
			var reNum = '' //返回结果
			//遍历整个数组对象
			for (var i = 0; i < arrData.length; i++) {
				//跳过最后一个元素的比较
				if (i + 1 == arrData.length) {
					continue
				}
				//判断相邻的元素是否相同
				if (arrData[i] == arrData[i + 1]) {
					reNum = arrData[i]
				}
			}
			return reNum
		},
		saveVariantInfoEdit1() {
			let text = '';
			if(this.activeName == '常用变体' || this.activeName == '常用变体组合'){
				this.selectVariants.尺寸 = [];
				this.selectVariants.颜色 = [];
				this.selectVariants.产品数量 = [];
			}
			if(this.activeName == '常用变体'){
				text = this.historyValue;
				const arr = text.split('，');
				for(let i = 0; i < arr.length; i++){
					const key = arr[i].split('：')[0];
					const val = arr[i].split('：')[1].split(',');
					this.$set(this.selectVariants, key, val)
				}
				this.saveVariantInfoEdit()
			}else if(this.activeName == '常用变体组合'){
				console.log(this.historyValueTag);
				const text = this.historyValueTag;
				const arr = text.split('，');
				const biaoshiArr = [];
				const map = {};
				arr.forEach(textItem => {
					const item = textItem.split('---'); // [颜色：Black]
					const biaoshi = item.map(key => key.split('：')[1]).join('-');
					biaoshiArr.push(biaoshi);
					
					item.forEach(key => {
						const keyArr = key.split('：');
						const keyName = keyArr[0];
						const keyValue = keyArr[1];
						if(map[keyName]){
							if(!map[keyName].includes(keyValue)){
								map[keyName].push(keyValue);
							}
						}else{
							map[keyName] = [keyValue];
						}
					})
				})
				for(let k in map){
					this.$set(this.selectVariants, k, map[k])
				}
				this.saveVariantInfoEdit()
				this.tableData = this.tableData.filter(item => {
					return biaoshiArr.includes(item.variantTag)
				})
			}else {
				text = this.variantText;
				if (!text) return
				const arrData = text
					.replace(/，/g, ',')
					.split(',')
					.filter((item) => !!item)

				if (this.CheckArrayElement(arrData) != '') {
					this.$message.error(
						this.CheckArrayElement(arrData) +
							'此项已选择，每项只可选择一次！'
					)
					return
				}
				// console.log("没有重复")
				// return
				this.selectVariants[this.specsIndex] = arrData
				this.saveVariantInfoEdit()
			}
		},
		// 删除
		delet(key) {
			this.selectVariants[key] = []
			this.saveVariantInfoEdit()
		},
		calculate_Variant_price(variantItem) {
			// console.log(variantItem);
			const { inputPrice } = variantItem
			const handleInputPrice = this.toDecimal2(this.parseNum(inputPrice))
			this.$set(variantItem, 'inputPrice', handleInputPrice)
		},
		toDecimal2(x) {
			var a = parseFloat(x)
			if (isNaN(a)) {
				return '0.00'
			}
			var f = Math.round(x * 100) / 100
			var s = f.toString()
			var rs = s.indexOf('.')
			if (rs < 0) {
				rs = s.length
				s += '.'
			}
			while (s.length <= rs + 2) {
				s += '0'
			}
			return s
		},
		parseNum(num) {
			let result = Number(num)
			if (isNaN(result)) {
				return 0
			}
			return result
		},
		deleteRow(item, index) {
			this.tableData.splice(index, 1)
			this.childValue = this.tableData
		},
		// 选择颜色和尺寸
		putText(item) {
			// console.log(item);
			let en_value = item.split('-')[1] ? item.split('-')[1].trim() : item
			let variantTextArray = []
			if (this.variantText) {
				variantTextArray = this.variantText.split(',')
			}
			if (variantTextArray.some((item) => item === en_value)) {
				this.$message.error('已选择此项')
				return false
			}
			variantTextArray.push(en_value)
			this.variantText = variantTextArray.join(',')
		},
		// 请选择变体名称
		getVariantSelect(val) {
			this.variantText = ''
			// 反显之前的选择的颜色或尺寸
			this.variantText =
				this.selectVariants[this.specsIndex] &&
				this.selectVariants[this.specsIndex].join(',')
			if (val === '尺寸') {
				this.recommendSpecs = sizeList.sizeList
			} else if (val === '颜色') {
				this.recommendSpecs = colorList.colorList
			} else if (val === '产品数量') {
				this.recommendSpecs = productNumberList.productNumberList
			}
		},

		changeEnable() {
			this.tableData.forEach((ele) => {
				ele.checked = !ele.checked
			})
		},
		// 加减价选择变体
		VariantPriceSame(val, item) {
			let showPrice = item.showPrice
			let inputPrice = item.inputPrice
			if (val === 'all_variant') {
				this.tableData.map((ele) => {
					this.$set(ele, 'showPrice', ele.showPrice)
					this.$set(ele, 'inputPrice', inputPrice)
				})
			} else {
				let selectType = ''
				if (val === '颜色') {
					selectType = item.color
				} else if (val === '尺寸') {
					selectType = item.size
				}
				this.tableData.forEach((item2) => {
					const variantTagArr = [];
					variantTagArr.push(
						item2.variantTag.slice(0,item2.variantTag.indexOf('-')),
						item2.variantTag.slice(item2.variantTag.indexOf('-')+1,item2.variantTag.length)
					)
					const result = variantTagArr.includes(selectType)

					if (result) {
						this.$set(item2, 'showPrice', item2.showPrice)
						this.$set(item2, 'inputPrice', inputPrice)
					}
				})
			}
			this.$message.success('操作成功')
			this.variant_price_same_value = ''
		},
		// 选择图片
		Select_pictures(row) {
			this.checkedSKU = row.sku
			this.dialogFormVisible = true
			this.Select_picturesitem = row
			this.variantSelectImage_form.images = row.imagesList
		},
		// 删除图片
		handleRemove(item, index) {
			item.imagesList.splice(index, 1)
		},
		// 放大图片
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url
			this.dialogVisible = true
		},
		// 选择图片确定
		saveVariantSelectImg() {
			this.dialogFormVisible = false
			this.tableData.forEach((item) => {
				if (this.checkedSKU === item.sku) {
					item.imagesList = this.variantCheckedImgUidList
				}
			})
			this.variantCheckedImgUidList = []
		},
		// 已选图片
		Selected_pictures(item, index, dd) {
			console.log(item, dd)
			this.isShowVariantImg = true
			this.variantImages = item.imagesList
			console.log(this.variantImages, 'bianti')
			this.$emit('Variant', this.variantImages)
		},
		//变体图片应用至
		Selected_picturesSame(val, item) {
			let imagesList = item.imagesList
			if (val === 'all_variant') {
				this.tableData.map((ele) => {
					this.$set(ele, 'imagesList', imagesList)
				})
			} else {
				let selectType = ''
				if (val === '颜色') {
					selectType = item.color
				} else if (val === '尺寸') {
					selectType = item.size
				}
				this.tableData.forEach((item2) => {
					const variantTagArr = item2.variantTag.split('-')
					const result = variantTagArr.includes(selectType)
					if (result) {
						this.$set(item2, 'imagesList', imagesList)
					}
				})
			}
			this.$message.success('操作成功')
			this.Selected_pictures_value = ''
		},
		// 重新定价
		Repricing(val, item) {
			let showPrice = item.showPrice
			let productPrice = item.productPrice
			if (val === 'all_variant') {
				this.tableData.map((ele) => {
					this.$set(ele, 'showPrice', showPrice)
					this.$set(ele, 'productPrice', productPrice)
				})
			} else {
				let selectType = ''
				let typeKey = ''
				if (val === '颜色') {
					selectType = item.color
					typeKey = 'color'
				} else if (val === '尺寸') {
					selectType = item.size
					typeKey = 'size'
				}
				// console.log(selectType)
				this.tableData.forEach((item2) => {
					// const variantTagArr = item2.variantTag.split("-");
					// const result = item2[typeKey].includes(selectType)
					const result = item2[typeKey] == selectType
					// console.log(item2[typeKey] == selectType)
					// console.log(result)
					if (result) {
						// console.log(JSON.parse(JSON.stringify(item2)))
						this.$set(item2, 'showPrice', showPrice)
						this.$set(item2, 'productPrice', productPrice)
					}
				})
			}
			this.$message.success('操作成功')
			this.variant_price_value = ''
		},
		// 查看定价
		Viewpricing(row) {
			console.log(JSON.parse(JSON.stringify(row)));
			this.checkedSKU = row.sku;
			this.priceData = row.productPriceObject;
			this.$refs.OneClickPrice.dialogOpen();
		},
		changeVariantSelectImg(item, index, event) {
			if (event.shiftKey && this.lastSelectedIndex !== null) {
				// shift 多选
				const start = Math.min(this.lastSelectedIndex, index);
				const end = Math.max(this.lastSelectedIndex, index);
				const rangeItems = this.imgSelectList.slice(start, end + 1);

				// 过滤掉已选中的
				const toAdd = rangeItems.filter(
					img => !this.variantCheckedImgUidList.some(key => key === img)
				);

				const remainSlots = 9 - this.variantCheckedImgUidList.length;

				if (toAdd.length > remainSlots) {
					this.variantCheckedImgUidList.push(...toAdd.slice(0, remainSlots));
					this.$message.error('变体图片最多选择9张');
				} else {
					this.variantCheckedImgUidList.push(...toAdd);
				}

			}else{
				if (this.variantCheckedImgUidList.length <= 0) {
					this.variantCheckedImgUidList.push(item)
				} else {
					const isHaveIndex = this.variantCheckedImgUidList.findIndex(
						(key) => key === item
					)

					if (isHaveIndex > -1) {
						this.variantCheckedImgUidList.splice(isHaveIndex, 1)
					} else {
						if (this.variantCheckedImgUidList.length < 9) {
							this.variantCheckedImgUidList.push(item)
						} else {
							this.$message.error('变体图片最多选择9张')
						}
					}
				}
				// 只有普通单击才更新基准点
				this.lastSelectedIndex = index;
			}
		},
		getVariantSelectImgIndex(item) {
			const isHaveIndex = this.variantCheckedImgUidList.findIndex(
				(key) => key === item
			)
			return isHaveIndex + 1
		},
		uploadVariantImagesSuccess(response, file) {
			const imgPath = file.response.data
			// this.productPicUrl.push(imgPath);
			this.$emit('addImg', imgPath)
		},
		handleSKU() {
			this.tableData.forEach((item) => {
				const arr = []
				this.productInfo.sku && arr.push(this.productInfo.sku)
				item.color && arr.push(item.color)
				item.size && arr.push(item.size)
				item.sku = arr.join('-')
			})
		},
		priceChange(value) {
			const countryTap = this.productInfo.areaName
			this.tableData.forEach((item) => {
				item.showPrice = value
				item.productPrice[countryTap].value = value
			})
		},
	},
}
</script>
<style lang="scss" parent scoped>
.Ministerbackground {
	overflow: hidden;
	border-color: #d2f1f0;
	background: #d2f1f0 !important;

	.Minister-top-color {
		background: #1cbbb4 !important;
	}
}

.checked-img-container {
	width: 100%;
	height: 36px;
	display: flex;
	align-items: flex-end;
	margin-bottom: 5px;

	.img-box {
		width: 28px;
		height: 28px;
		border-radius: 4px;
		position: relative;
		margin-right: 10px;
		line-height: 28px;

		img {
			width: 100%;
			height: 100%;
			border: 1px solid #dcdfe6;
		}

		.el-icon-circle-close {
			display: none;
			position: absolute;
			right: -7px;
			top: -7px;
			color: #999;
			font-size: 14px;
			font-weight: 700;
			cursor: pointer;
		}

		&:hover .el-icon-circle-close {
			display: block;
		}
	}
}

.image-container {
	display: flex;
	flex-wrap: wrap;

	.img-box {
		width: 178px;
		height: 178px;
		margin-right: 10px;
		margin-bottom: 10px;
		border: 1px solid #eee;
		border-radius: 6px;

		img {
			width: 100%;
			height: 100%;
		}
	}
}

.select-img {
	width: 100%;
	height: 320px;
	overflow: auto;

	.option {
		width: 148px;
		height: 148px;
		margin: 0 8px 8px 0;
		float: left;
		overflow: hidden;
		background-color: #fff;
		border: 1px solid #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		position: relative;

		.img-mask {
			position: absolute;
			right: -17px;
			top: -7px;
			width: 46px;
			height: 26px;
			background: #13ce66;
			text-align: center;
			transform: rotate(45deg);

			.el-true-check {
				color: #fff;
				font-size: 12px;
				margin-top: 12px;
				transform: rotate(-45deg);
			}
		}

		img {
			width: 146px;
		}
	}
}

.custom-update {
	/deep/ .el-upload--picture-card {
		background: initial;
		border: initial;
		width: initial;
		height: initial;
		line-height: initial;
	}
}
.mb10{
	margin-bottom: 10px;
}
.variant {
	width: 97%;
	margin: auto;

	.variant_top {
		width: 100%;
		margin-top: 20px;
		display: flex;
		align-items: center;
		.mr20{
			margin-right: 20px;
		}
	}

	.variant_content {
		margin: 30px 0;
	}
}
.keyword-list{
	.el-radio{
		display: block;
		margin: 0 !important;
		margin-bottom: 5px !important;
	}
	&.box{
		.item{
			display: flex;
			align-items: center;
			.el-button{
				margin-left: 10px;
			}
		}
	}
	
}
.active_variants{
	display: flex;
	align-items: center;
	margin-top: 20px;
	.active_variants_item{
		margin-right: 50px;
	}
}
.select-row{
	display: flex;
	align-items: center;
	/deep/ .el-inpit{
		margin: 0;
	}
}
.variant-radio {
	display: flex;
	/* 覆盖默认的 inline-flex */
	align-items: flex-start;
	height: auto !important;
	/* 覆盖 el-radio border 模式的固定高度 */
	width: 100%;
	margin-bottom: 8px;
	margin-right: 0 !important;
	padding: 10px 15px;
	white-space: normal;
	/* 允许换行 */
	box-sizing: border-box;
}

/* 让内部 label 文字也能换行 */
.variant-radio /deep/ .el-radio__label {
	white-space: normal;
	word-break: break-all;
	line-height: 1.5;
}
</style>
